var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.symptoms.length > 0
    ? _c("div", [
        _c("div", { staticClass: "info--text text-uppercase my-3 mt-2" }, [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.generateMessage("requests.details.titles.specificSymptoms")
              ) +
              "\n  "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex flex-wrap" },
          [
            _c(
              "v-col",
              { attrs: { cols: "12", md: "6" } },
              [
                _c("div", { staticClass: "font-weight-bold" }, [
                  _vm._v("Types de symptômes spécifiques")
                ]),
                _vm._v(" "),
                _c("v-data-table", {
                  staticClass:
                    "secondarybackground striped-table clickable ma-2",
                  attrs: {
                    dense: "",
                    loading: _vm.symptomsLoading,
                    "hide-default-footer": "",
                    "fixed-header": "",
                    height: "300",
                    "disable-sort": "",
                    "disable-pagination": "",
                    items: _vm.symptoms,
                    headers: _vm.symptomsHeaders
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "item",
                        fn: function({ item }) {
                          return [
                            _c(
                              "tr",
                              {
                                class: { selected: item.code === _vm.typeCode },
                                on: {
                                  click: function($event) {
                                    return _vm.selectType(item)
                                  }
                                }
                              },
                              [
                                _c("td", [_vm._v(_vm._s(item.name))]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(item.intervention_contract_period)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(item.category_name))]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(item.sub_category_name))
                                ])
                              ]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    318108219
                  )
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-col",
              { attrs: { cols: "12", md: "6" } },
              [
                _c("div", { staticClass: "font-weight-bold" }, [
                  _vm._v("Qualification de symptôme")
                ]),
                _vm._v(" "),
                _c("v-data-table", {
                  staticClass: "secondarybackground striped-table ma-2",
                  attrs: {
                    dense: "",
                    loading: _vm.qualificationsLoading,
                    "hide-default-footer": "",
                    "fixed-header": "",
                    height: "300",
                    "disable-sort": "",
                    "disable-pagination": "",
                    items: _vm.typeCode ? _vm.qualifications : [],
                    headers: _vm.qualificationsHeaders
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }